import { SignIn } from "@clerk/clerk-react";

export default function LoginPage(): React.ReactElement {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--surface-2)",
      }}
    >
      <div>
        <p style={{ textAlign: "center", color: "var(--body)", fontSize: 14 }}>
          Access is by invitation only.
        </p>
        <SignIn
          routing="path"
          path="/login"
          appearance={{ elements: { footerAction: "hidden" } }}
        />
      </div>
    </div>
  );
}
